export interface DirectDebitSetupContext {
  setupRequestId: string;
  packageId: string;
  familyId?: string | null;
  familySubscriptionId?: string | null;
  billingRequestId?: string | null;
  billingRequestFlowId?: string | null;
  createdAt: string;
  expiresAt: string;
}

export const directDebitSetupStorageKey = "directDebitSetupRequest";

export function readDirectDebitSetupContext(): DirectDebitSetupContext | null {
  try {
    const raw = localStorage.getItem(directDebitSetupStorageKey);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as Partial<DirectDebitSetupContext>;
    if (!parsed.setupRequestId || !parsed.packageId || !parsed.createdAt || !parsed.expiresAt) {
      localStorage.removeItem(directDebitSetupStorageKey);
      return null;
    }

    return {
      setupRequestId: parsed.setupRequestId,
      packageId: parsed.packageId,
      familyId: typeof parsed.familyId === "string" ? parsed.familyId : null,
      familySubscriptionId: typeof parsed.familySubscriptionId === "string" ? parsed.familySubscriptionId : null,
      billingRequestId: typeof parsed.billingRequestId === "string" ? parsed.billingRequestId : null,
      billingRequestFlowId: typeof parsed.billingRequestFlowId === "string" ? parsed.billingRequestFlowId : null,
      createdAt: parsed.createdAt,
      expiresAt: parsed.expiresAt,
    };
  } catch {
    localStorage.removeItem(directDebitSetupStorageKey);
    return null;
  }
}

export function writeDirectDebitSetupContext(context: DirectDebitSetupContext) {
  try {
    localStorage.setItem(directDebitSetupStorageKey, JSON.stringify(context));
  } catch {
    // Best-effort only.
  }
}

export function clearDirectDebitSetupContext() {
  try {
    localStorage.removeItem(directDebitSetupStorageKey);
  } catch {
    // Ignore storage issues on cleanup.
  }
}
